import { render } from "./AddClientInitiatorField.vue?vue&type=template&id=69289d8d"
import script from "./AddClientInitiatorField.vue?vue&type=script&lang=js"
export * from "./AddClientInitiatorField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__